import React, { useState } from 'react';
import { sendOrionConfiguration } from '../../../services/emailService';
import EmailCard from '../cards/EmailCard';

/**
 * DownloadDocumentation component allows users to download selected modules' documentation
 * by entering an email address. The component includes an email form and sends the configuration
 * details (selected modules, price, and delivery time) to the backend upon submission.
 * 
 * @component
 * @param {Object} props - The properties object.
 * @param {Array} props.selectedModules - Array of selected modules to include in the documentation.
 * @param {number} props.price - The total price of the selected modules.
 * @param {string} props.deliveryTime - Estimated delivery time for the selected modules.
 */
const DownloadDocumentation = ({ 
  /**
  * Array of selected modules to include in the documentation.
  */
 selectedModules,
 /**
  * The total price of the selected modules.
  */
 price,
 /**
  * Estimated delivery time for the selected modules.
  */
 deliveryTime
}) => {
  const [showEmailCard, setShowEmailCard] = useState(false);
  const [email, setEmail] = useState('');

  /**
   * Handles the display of the EmailCard component when the user clicks the "Download Documentation" button.
   */
  const handleShowEmailCard = () => {
    setShowEmailCard(true);
  };

  /**
   * Closes the EmailCard component.
   */
  const handleCloseCard = () => {
    setShowEmailCard(false);
  };

  /**
   * Handles the submission of the email and sends the selected modules, price, and delivery time to the backend.
   * Alerts the user in case of success or failure.
   */
  const handleEmailSubmit = async () => {
    if (!email) {
      alert('Please enter your email.');
      return;
    }
    try {
      const response = await sendOrionConfiguration(email, selectedModules, price, deliveryTime);
      if (response.status === 'success') {
        alert('Orion configuration sent successfully!');
      } else {
        alert('Failed to send configuration.');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Error sending configuration.');
    }
  };

  return (
    <div>
      <button
        onClick={handleShowEmailCard}
        style={{
          display: 'inline-block',
          backgroundColor: 'transparent',
          fontSize: '16px',
          fontWeight: 'bold',
          color: '#fff',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          textAlign: 'center',
          textDecoration: 'underline' // Add underline to the text
        }}
      >
        Download Documentation
      </button>

      {showEmailCard && (
        <EmailCard
          email={email}
          setEmail={setEmail}
          onSubmit={handleEmailSubmit}
          onClose={handleCloseCard}
        />
      )}
    </div>
  );
};

/**
 * Exports the DownloadDocumentation component as the default export.
 */
export default DownloadDocumentation;
